import React, { useCallback } from 'react';
import Link from 'next/link';
import { ICurrentCity } from '~/src/store/reducers/city';
import { LK_HREF, ZERO } from '~/src/components/Header/Profile';
// @ts-ignore
import * as ST from './styled';
import { dataLayerPush } from '@stelecom/ui-react/components/helpers';
import { CATEGORIES, EVENTS } from '~/src/constants/analytics';
import { Profile, ProfileAuth } from '../Profile/styled';
import { IClientPersonal } from '~/src/store/reducers/auth';
import phone from '~/static/images/header/phone.svg';

interface IProps {
  openCitySelect: () => void;
  city: ICurrentCity;
  cookieDomain?: string;
  isAuth: boolean;
  isDesktop: boolean;
  closeHandler: () => void;
  clientInfo: IClientPersonal | null;
  productsInfo: {
    productId: number;
  }[];
  logout: () => void;
  href: string;
  isTablet?: boolean;
  callPopUpHandler: () => void;
}

const RightMenu = ({
  // city,
  isAuth,
  closeHandler,
  clientInfo,
  isDesktop,
  logout,
  callPopUpHandler,
}: IProps): JSX.Element => {
  const sendAuthEvent = useCallback(
    (action = 'Войти в личный кабинет') => {
      dataLayerPush({
        event: EVENTS.UAevent,
        category: CATEGORIES.mainMenuClick,
        action,
        label: 'menu_new',
      });
      closeHandler && closeHandler();
    },
    [closeHandler]
  );

  return (
    <ST.RightMenu>
        <ST.PhoneWrapper>
          <img src={phone} alt='phone' />
          <ST.HeaderPhoneRight
            href={'tel:+74951458555'}
            className='js-calltouch-phone'
            data-test='phone'
          >
            +7 (495) 145 85 55
          </ST.HeaderPhoneRight>
          <ST.HeaderPhoneRight
            href={'tel:+74958033777'}
            className='js-calltouch-phone'
            data-test='phone'
          >
            +7 (495) 803 37 77
          </ST.HeaderPhoneRight>
          {isDesktop && (
            <ST.StyledTopMenuItem className={'element'} onClick={callPopUpHandler}>
              Перезвоните мне
            </ST.StyledTopMenuItem>
          )}
        </ST.PhoneWrapper>

      {isAuth ? (
        <ProfileAuth>
          {clientInfo && (
            <ST.Name data-test='lk-fio' content={clientInfo?.fio[ZERO]}>
              {clientInfo?.fio}
              <ST.ExitElement onClick={logout} />
            </ST.Name>
          )}
        </ProfileAuth>
      ) : (
        isDesktop && (
          <ST.HideOnMobile onClick={closeHandler}>
            <Link href={LK_HREF} passHref>
              <Profile onClick={() => sendAuthEvent('Войти в личный кабинет')}>
                <ST.Login data-test='lk-login'>Войти в ЛК</ST.Login>
              </Profile>
            </Link>
          </ST.HideOnMobile>
        )
      )}
    </ST.RightMenu>
  );
};

export default RightMenu;
